import markStore, * as MarkStore from './markStore';

export type MarkModel = MarkStore.MarkModel;

export default markStore;
